(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-inquiry-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('[data-open-modal="contact-email-us"]');
    const modal = document.getElementById('contactform-inquiry-modal');
    const model_hide_all = document.getElementById('customerCareModal');
    //if (!modal || !button.length) return;

    const closeBtn = modal.querySelectorAll('.close-contact-inquiry');
    let previousScrollY = 0;

    //console.log("button", button);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      console.log('button clicked', event);
      open_contact_modal();
      close_modal_Parent();
    });
    //  button.forEach(btn => {
    //   console.log("buttonssss", btn);
    //   btn.addEventListener('click', (event) => {
    //     event.preventDefault();
    //     if (btn.dataset.enabledCustomerForm === 'true') {
    //       open_contact_modal();
    //     }
    //   });
    // });
    function open_contact_modal() {
      const scrollY = window.scrollY;
      previousScrollY = scrollY;

      // Prevent layout thrashing by separating DOM reads from DOM writes
      requestAnimationFrame(() => {
        document.body.dataset.scrollY = scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';

        modal.classList.add('show');
        modal.setAttribute('open', true);
        setupLiveValidation();
      });
    }
    function close_contact_modal() {
      modal.classList.remove('show');
      modal.removeAttribute('open');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      delete document.body.dataset.scrollY;
      window.scrollTo({ top: previousScrollY, behavior: 'instant' });
    }

     function close_modal_Parent () {
      model_hide_all.classList.remove('show');
      model_hide_all.removeAttribute('open');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    }

    if (closeBtn) {
      closeBtn.forEach((btnClose) => {
         btnClose.addEventListener('click', close_contact_modal);
      });
     
    }
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        close_contact_modal();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('show')) {
        close_contact_modal();
      }
    });
    function setupLiveValidation() {
      const form = modal.querySelector('form.contact-form__form');
      if (!form) return;

      const submitBtn = form.querySelector('button[type="submit"]');
      if (!submitBtn) return;

      // Required fields
      const requiredFields = [
        form.querySelector('input[name="contact[first_name]"]'),
        form.querySelector('input[name="contact[last_name]"]'),
        form.querySelector('input[name="contact[email]"]'),
        form.querySelector('select[name="contact[inquiry]"]'),
        // form.querySelector('textarea[name="contact[body]"]')
      ];

      // Minimum length per field (can adjust)
      const minLengths = {
        'contact[first_name]': 3,
        'contact[last_name]': 3,
        'contact[email]': 15,
        'contact[inquiry]': 1,
        // 'contact[body]': 5
      };

      function validateLive() {
        let isValid = true;

        requiredFields.forEach((field) => {
          if (!field) return;

          const value = field.value.trim();
          const minLength = minLengths[field.name] || 1;

          if (!value || value.length < minLength) {
            isValid = false;
            field.classList.add('is-invalid');
          } else {
            field.classList.remove('is-invalid');
          }
        });

        submitBtn.disabled = !isValid;
      }

      // Bind live validation
      requiredFields.forEach((field) => {
        if (!field) return;
          const all_value = field.value.trim();
          const all_minLength = minLengths[field.name] || 1;
          if (!all_value || all_value.length < all_minLength) {
             // Disable submit initially
              submitBtn.disabled = true;
          } else {
             submitBtn.disabled = false;
          }

        const eventType = field.tagName === 'SELECT' ? 'change' : 'input';
        field.addEventListener(eventType, validateLive);
      });

      // Optional: initial validation for prefilled fields
      //validateLive();
    }

    
    let expectedContactId  = document.querySelector("#contactform-inquiry-modal")?.dataset.sectionId;
    const hash = window.location.hash.replace("#", "");
    if (hash === expectedContactId) {
      // enable popup here
       open_contact_modal();
    } else {
      //console.log("Contact ID not matched");
    }

  });
  } catch(e) { console.error(e); }
})();

})();
